import { useContext, memo, useMemo, useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import axiosConn from '../../axiosConn';
import Topbar from '../../components/topbar/Topbar';
import TopbarNotification from '../../components/topbarNotification/TopbarNotification';
import Sidebar from '../../components/sidebar/Sidebar';
import Feed from '../../components/feed/Feed';
import Rightbar from '../../components/rightbar/Rightbar';
import { useMediaQuery } from 'react-responsive';
import { ViewPortContext } from '../../context/ViewPortContext';
import arePropsEqual from '../../arePropsEqual';
import './home.css';
import { useGetConversations } from '../../hooks/useGetConversations';
import { AuthContext } from '../../context/AuthContext';
import HitLabProfileReadyHomeCard from '../hitlab/HitLabProfileReadyHomeCard';
import {
  clearHitLabProfileReadyMarker,
  getHitLabPlayerId,
  hasHitLabProfileReadyMarker,
  isHitLabHomeResumeActivationSearch,
  isHitLabProfileReadyResumeIntake,
  shouldClearHitLabProfileReadyMarkerForIntake,
} from '../hitlab/hitLabProfileReady';
import {
  HITLAB_FUNNEL_EVENTS,
  recordHitLabEvent,
} from '../hitlab/hitLabTelemetry';

export default memo(function Home() {
  const mobileView = useMediaQuery({
    query: '(max-width: 805px)',
  });
  const { width } = useContext(ViewPortContext);
  const [conversations, setConversations] = useState([]);
  const [totalUnReadMessages, setTotalUnReadMessages] = useState(0);
  const { player } = useContext(AuthContext);
  const location = useLocation();
  const authConfig = useMemo(
    () =>
      player?.token
        ? { headers: { Authorization: `Bearer ${player.token}` } }
        : null,
    [player?.token],
  );
  const hitLabPlayerId = useMemo(() => getHitLabPlayerId(player), [player]);
  const hasProfileReadyMarker = hasHitLabProfileReadyMarker(hitLabPlayerId);
  const shouldCheckHitLabResume =
    isHitLabHomeResumeActivationSearch(location.search) ||
    hasProfileReadyMarker;
  const [hitLabResumeIntake, setHitLabResumeIntake] = useState(null);
  const [hitLabResumeVisible, setHitLabResumeVisible] = useState(false);

  useEffect(
    () => {
      let active = true;
      setHitLabResumeVisible(false);
      setHitLabResumeIntake(null);
      if (!shouldCheckHitLabResume || !authConfig) {
        return () => {
          active = false;
        };
      }

      axiosConn
        .get('hitlab/intake/me', authConfig)
        .then((response) => {
          if (!active) return;
          const nextIntake = response.data?.data?.intake || null;
          if (isHitLabProfileReadyResumeIntake(nextIntake)) {
            setHitLabResumeIntake(nextIntake);
            setHitLabResumeVisible(true);
            return;
          }
          if (shouldClearHitLabProfileReadyMarkerForIntake(nextIntake)) {
            clearHitLabProfileReadyMarker(hitLabPlayerId);
          }
          setHitLabResumeVisible(false);
        })
        .catch(() => {
          if (!active) return;
          setHitLabResumeVisible(false);
        });

      return () => {
        active = false;
      };
    },
    [authConfig, hitLabPlayerId, shouldCheckHitLabResume],
  );

  const recordHitLabHomeResumeClick = () => {
    void recordHitLabEvent(HITLAB_FUNNEL_EVENTS.PROFILE_READY_HOME_RESUME_CLICKED, {
      search: location.search,
      path: '/home',
      status: hitLabResumeIntake?.status || 'pending_payment',
      dedupe: false,
    });
  };

  const onSuccess2 = (data) => {
    // console.log('data: ', data);
  };

  const onError2 = (err) => {
    // console.log('err: ', err);
  };

  const {
    data: conversationsData,
    isSuccess,
    status: conversationStatus,
    refetch,
  } = useGetConversations(onSuccess2, onError2, player);
  // console.log(data);

  useEffect(() => {
    //set conversations
    if (isSuccess) {
      // console.log(isSuccess);
      setConversations(conversationsData);
    }
  }, [conversationsData, isSuccess]);

  //console.log(width);

  return (
    <>
      {/* <Topbar /> */}
      {/* <Topbar
        conversationsData={conversationsData}
        conversationsStatus={conversationStatus}
        refetchConversations={refetch}
        parent="Home"
        conversations={conversations}
        setConversations={setConversations}
        totalUnReadMessages={totalUnReadMessages}
        setTotalUnReadMessages={setTotalUnReadMessages}
      />
      {mobileView && <TopbarNotification />} */}
      <div className="homeContainer">
        {!mobileView && <Sidebar />}
        <div className="homeMainColumn">
          {hitLabResumeVisible ? (
            <HitLabProfileReadyHomeCard onResume={recordHitLabHomeResumeClick} />
          ) : null}
          <Feed />
        </div>
        {!mobileView && <Rightbar />}
      </div>
    </>
  );
}, arePropsEqual);
